import classNames from 'classnames';
import styles from './ContentSection.module.scss';

export interface ContentSectionProps {
	className?: string;
	children?: React.ReactNode;
	title?: string;
}

export const ContentSection: React.FC<ContentSectionProps> = ({ children, className, title }) => {
	return (
		<section aria-label={title} className={classNames(styles.ContentSection, className)}>
			{children}
		</section>
	);
};
